import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { Layout } from '../components/layout/layout';
import { ApplicationRoutes } from '../constants/appRoutes';
import { CustomerLayout } from '../components/layout/customerLayout';

export const AccountManagementItems: RouteItem = {
  path: '/',
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout />,
  subItems: [
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: ApplicationRoutes.account.resetPassword,
      async lazy() {
        const component = await import('../features/auth/ResetPassword');
        return { Component: component.ResetPasswordPage };
      }
    },
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: ApplicationRoutes.account.forgotPassword,
      async lazy() {
        const component = await import('../features/auth/ForgotPassword');
        return { Component: component.ForgotPasswordPage };
      }
    }
  ]
};

export const CustomerItems: RouteItem = {
  path: `${ApplicationRoutes.customer.checklist}/:cleaning`,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  disableDefaultNavItem: true,
  layout: <CustomerLayout />,
  async lazy() {
    const component = await import('../features/customerChecklist/CustomerChecklist');
    return { Component: component.CustomerChecklist };
  }
};

export const LogoutRouteItem: RouteItem = {
  text: 'Logout',
  layout: <Layout />,
  disableDefaultNavItem: true,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],
  path: ApplicationRoutes.account.logout,
  async lazy() {
    const component = await import('../features/auth/Logout');
    return { Component: component.Logout };
  }
};

export const MyAccountRouteItem: RouteItem = {
  text: 'My Account',
  layout: <Layout />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  disableDefaultNavItem: true,
  allowedRoles: [],
  path: ApplicationRoutes.account.myProfile,
  async lazy() {
    const component = await import('../features/auth/MyProfile');
    return { Component: component.MyProfile };
  }
};

export const LoginRouteItem: RouteItem = {
  path: ApplicationRoutes.account.login,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  text: 'Login',
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/Login');
    return { Component: component.LoginPage };
  }
};
